export enum CollectingFrom {
  CHILDREN = 'CHILDREN',
  RESERVER = 'RESERVER',
  BENEFICIARY = 'BENEFICIARY',
  CUSTOMER = 'CUSTOMER',
}
